<template>
    <!--弹窗-->
    <el-dialog
        width="300px"
        title="导出Excel"
        :visible.sync="visible"
        :before-close="handleClose"
        append-to-body
    >

        <span slot="footer" class="dialog-footer">
            <el-button @click="exportConfirm(true)" type="primary" size="mini" :loading="loading">全部数据</el-button>
            <el-button @click="exportConfirm" type="success" size="mini" :loading="loading">筛选数据</el-button>
        </span>

    </el-dialog>
</template>
<script>

import * as api from '@/api/advAnalys/advAnalys'
import {downloadFileUrl} from '@/utils/method'
import {
    manager_export_manager_finish_allocate_production_list,
    manager_export_manager_waiting_allocate_production_list
} from '@/api/advAnalys/advAnalys'

export default {
    data() {
        return {
            disregarded_reason: null,
            visible: false,
            formData: {},
            loading: false,
            type: 0
        }
    },
    methods: {
        openModal(data, type = 0) {
            this.formData = JSON.parse(JSON.stringify(data))
            this.type = type
            this.visible = true
        },
        exportConfirm(flag) {
            let param = flag === true ? {} : this.formData
            this.loading = true
            const tempPromise = this.type === 0 ? api.manager_export_manager_waiting_allocate_production_list(param) : api.manager_export_manager_finish_allocate_production_list(param)
            tempPromise.then(res => {
                if (res.code === 0) {
                    this.$message.success('导出成功')
                    this.downFile(res.data)
                    this.handleClose()
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.$message({type: 'error', message: res.message})
            }).finally(() => {
                this.loading = false
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({type: 'error', message: '无法下载！'})
            }
            downloadFileUrl(path)
        },
        // 关闭弹窗
        handleClose() {
            this.visible = false
            this.loading = false
            this.formData = {}
        }
    }
}
</script>
<style type="text/scss" lang="scss">
.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

